<div class="w-full text-center font-bold text-sm md:text-3xl p-5">
  {{ message }}
</div>